const Loading = () => (
  <div className="loading">
    <img src="/spinner.svg" height="50" alt="Loading" />
  </div>
)

export default Loading
